/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint-disable no-use-before-define */
/* eslint-disable new-cap */

const ONETRUST_DISABLED_SITES = ['star_agents', 'ibercuba']

// --- OneTrust Category Mappings ---
// Standard OneTrust category IDs
const ONETRUST_CATEGORY_STRICTLY_NECESSARY = 'C0001' // Strictly Necessary
const ONETRUST_CATEGORY_PERFORMANCE = 'C0002' // Performance / Analytics
const ONETRUST_CATEGORY_PERSONALIZATION = 'C0003' // Functional (sometimes used for personalization)
const ONETRUST_CATEGORY_TARGETING = 'C0004' // Advertising / Targeting (commonly for personalization and marketing)

// Mapping of your internal groups to OneTrust Category IDs
const ONETRUST_CATEGORY_IDS = {
  technical: ONETRUST_CATEGORY_STRICTLY_NECESSARY,
  analytics: ONETRUST_CATEGORY_PERFORMANCE,
  personalization: ONETRUST_CATEGORY_PERSONALIZATION, // Assuming your personalization cookies fall under Targeting
}

const TECHNICAL_COOKIES = [
  'X-MARKET',
  'x-country',
  'user_id',
  'locale',
  'currency',
  '_session_id',
  'accessibility_mode',
  'browsing_session',
  'clean_timestamp',
  'logged_messages',
  'my_iberostar_discount',
  'my_iberostar_discount_unchecked_by_user',
  'next_opening_hotels_popup_displayed',
  'notifications_shown',
  'remove_browsing',
  'resident',
  'show_myibe_discount',
  'seen_auto_pop_up',
  'user_web_name',
  'cookies_consent',
  'onetrust_cookies_consent',
  'check_user_id',
  'fastbooking_is_search',
  'userLogin',
  'logged_in_microsites',
  'no_lb',
  'cp_no_prom',
  'cp_no_prom_partpdv',
  'cp_no_prom_name',
  'cp_no_prom_image',
  'cp_expires_at',
  'cp_promotional',
  'campaign_cp_no_prom',
  'campaign_cp_no_prom_origin',
  'cp_to_crs',
  'shared_last_searches',
  'auth0_postregister_form',
  'user_metadata',
  'language',
  'fia_user_id',
  'fiacp',
  'cache_status_flag',
  'cachestatus',
  'token_partner',
]

const ANALYTICS_COOKIES = [
  'hotel_headquarter_origin',
  'hotel_headquarter_final',
  'last_access',
  'page_site_origin',
  'promotion_creative',
  'user_points',
  'user_level',
  'visitor_has_reservation',
  'visitor_type',
  'visitor_is_buyer',
  'visitor_session_id',
  'visitor_session_id_expire',
  'visitor_iberostar',
  'visitor_recurrence',
  'visitor_session_count',
  'crm_id',
  'affId',
  'network',
  'idCliente',
  'CampaignId',
  'j',
  'e',
  'l',
  'u',
  'jb',
  'mid',
  'login_success',
  'custom_var',
  'idevice_id',
  'idevice_type',
  'fastbooking_data_utag',
  'update_utag_data',
  'login_continue_as_google_user',
  'register_success_google_one_tap',
  'login_success_google_one_tap',
  'register_error',
  'register_success',
  'login_error',
  'agency_group_name',
  'business_agent_code',
  'business_code',
  'business_name',
  'business_type',
  'utag_user',
  'register_social_network_name',
  'google_one_tap_login',
  'social_network_name',
  'google_one_tap_login',
  'prelead_type',
]

const PERSONALIZATION_COOKIES = [
  'exit_partner',
  'visitor_is_repeater',
  'cp',
  'cp_name',
  'cp_image',
  'cp_partpdv',
  'campaign_cp',
  'campaign_cp_origin',
  'cjevent',
]

const REMOVABLE_COOKIES = [
  'visitor_session_id_expire',
  'hotel_headquarter_origin',
  'hotel_headquarter_final',
  'fastbooking_data_utag',
  'cp',
  'cp_expires_at',
  'cp_image',
  'cp_name',
  'cp_partpdv',
  'cp_promotional',
  'utag_user',
  'fia_user_id',
  'fiacp',
  'idevice_type',
  'idevice_id',
  'ihg_data',
  'register_error',
  'register_success',
  'update_utag_data',
  'cp_no_prom',
  'cp_no_prom_partpdv',
  'cp_no_prom_name',
  'cp_no_prom_image',
  'cp_to_crs',
  'token_partner',
  'login_success',
  'login_error',
  'login_continue_as_google_user',
  'register_success_google_one_tap',
  'register_social_network_name',
  'login_success_google_one_tap',
  'register_error',
  'register_success',
  'social_network_name',
  'google_one_tap_login',
  'auth0_postregister_form',
  'prelead_type',
]

if (isDebugConsolePresent()) {
  console.group('Cookies consent manager log - OneTrust')
}

export function readCookie(name) {
  const cookieArr = document.cookie.split(';')
  const found = cookieArr.find(c => c.split('=')[0].trim() === name)
  return found?.split('=')[1] // returns the value of the cookie if found, undefined otherwise
}

export function setCookie(
  c_name,
  value,
  exdays,
  path = null,
  domain = null,
  secure = null,
  httponly = null,
  sameSite = null,
  callback = null
) {
  const cookie = cookieOptions(exdays, path, domain, secure, httponly, sameSite)
  cookie['name'] = c_name
  cookie['value'] = value
  return setCookies(new Array(cookie), callback)
}

export function setCookies(cookies, callback) {
  const validCookies = []

  if (cookies !== null && cookies.length > 0) {
    cookies.forEach(function (cookie) {
      Object.assign(
        cookie,
        cookieOptions(
          cookie['expires'],
          cookie['path'],
          cookie['domain'],
          cookie['secure'],
          cookie['httponly'],
          cookie['sameSite']
        )
      )
      if (cookieIsAccepted(cookie)) {
        validCookies.push(cookie)
      } else {
        // If cookie is not accepted, add it to blockedCookies for potential future setting
        manageBlockedCookie(cookie)
      }
    })
  } else if (callback) {
    callback()
  }

  if (validCookies.length > 0) {
    const params = { cookies: JSON.stringify(validCookies) }
    const body = Object.keys(params)
      .map(key => {
        return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
      })
      .join('&')

    return fetch('/cookies/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      body,
    }).then(() => {
      if (callback) {
        callback()
      }
    })
  }
}

/**
 * Deletes a cookie by setting its expiration date to the past.
 * This function attempts to delete the cookie using various combinations of path and domain
 * to increase the chances of successful deletion, as these attributes must match
 * the original cookie's attributes exactly.
 *
 * @param {string} name - The name of the cookie to delete.
 * @param {string} [path] - The path of the cookie. If not provided, it will try with '/' and current path.
 * @param {string} [domain] - The domain of the cookie. If not provided, it will try without specifying a domain.
 */
function deleteCookie(name, path, domain) {
  // Standard expiration date in the past to force deletion
  const pastDate = 'Thu, 01 Jan 1970 00:00:00 UTC'

  // Helper to construct the cookie string for deletion
  const setCookieToDelete = (cookiePath, cookieDomain) => {
    let cookieString = `${name}=; expires=${pastDate};`

    // Append path if provided, otherwise default to '/'
    cookieString += `path=${cookiePath || '/'};`

    // Append domain if provided and not empty
    if (cookieDomain) {
      cookieString += `domain=${cookieDomain};`
    }
    document.cookie = cookieString
  }

  // --- Attempt deletion with various path/domain combinations ---

  // 1. Try with the provided path and domain (most specific attempt)
  // If path/domain are undefined, they will default to '/' and '' respectively in setCookieToDelete
  setCookieToDelete(path, domain)

  // 2. Try with the root path '/' and the provided domain
  // This is common if the cookie was set globally.
  setCookieToDelete('/', domain)

  // 3. Try with the provided path but without specifying a domain
  // The browser will then use the current host's domain by default.
  setCookieToDelete(path, '')

  // 4. Try with the root path '/' and without specifying a domain
  // This is often the most successful fallback for general cookies.
  setCookieToDelete('/', '')

  // 5. If the domain starts with a leading dot (e.g., .example.com),
  // try deleting it without the leading dot (e.g., example.com).
  // Some browsers/servers handle domains with and without the leading dot differently.
  if (domain && domain.startsWith('.')) {
    const nakedDomain = domain.substring(1) // Remove the leading dot
    setCookieToDelete(path, nakedDomain) // With provided path
    setCookieToDelete('/', nakedDomain) // With root path
  }
}

export function deleteCookies(cookieNames, callback) {
  const cookiesToDelete = []
  cookieNames.forEach(name => {
    // Only attempt to delete if the cookie actually exists
    if (typeof readCookie(name) !== 'undefined') {
      if (REMOVABLE_COOKIES.includes(name)) {
        cookiesToDelete.push({ name, value: '-1', expires: -1 })
      } else {
        const domain = IB.cookieManager.getDomainForCookie()
        cookiesToDelete.push({ name, value: '-1', expires: -1, domain, path: '/' }) // Set value to empty string and expires to past date
      }
    }
  })

  if (cookiesToDelete.length > 0) {
    // Send deletion requests to the server
    const params = { cookies: JSON.stringify(cookiesToDelete) }
    const body = Object.keys(params)
      .map(key => {
        return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
      })
      .join('&')

    fetch('/cookies/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      body,
    }).then(() => {
      // Also delete from client-side immediately for better UX
      cookiesToDelete.forEach(cookie => {
        deleteCookie(cookie.name, cookie.path, cookie.domain)
      })
      if (callback) {
        callback()
      }
    })
  } else if (callback) {
    callback()
  }
}

export function hasUserAcceptedCookies() {
  return typeof OneTrust !== 'undefined'
    ? OneTrust.IsAlertBoxClosedAndValid()
    : readCookie('onetrust_cookies_consent') === 'true' || readCookie('cookies_consent') === 'true'
}

function isDebugPresent() {
  return document.documentElement.dataset.debug === 'true'
}

function isDebugConsolePresent() {
  return document.documentElement.dataset['debugConsole'] === 'true'
}

function cookieOptions(exdays, path = null, domain = null, secure = null, httponly = null, sameSite = null) {
  const expires = exdays === null || exdays === undefined ? 365 : exdays
  return {
    expires,
    path,
    domain,
    secure,
    httponly,
    sameSite,
  }
}

function getGroupOfCookie(cookieName) {
  if (TECHNICAL_COOKIES.includes(cookieName)) {
    return 'technical'
  }
  if (ANALYTICS_COOKIES.includes(cookieName)) {
    return 'analytics'
  }
  if (PERSONALIZATION_COOKIES.includes(cookieName)) {
    return 'personalization'
  }
  return 'unknown'
}

/**
 * Checks if a given cookie group is accepted by OneTrust.
 * Uses the global OnetrustActiveGroups variable (which is a comma-separated string).
 * @param {string} group - The name of the cookie group (e.g., 'technical', 'analytics', 'personalization').
 * @returns {boolean} - True if the group is accepted, false otherwise.
 */
function groupIsAccepted(group) {
  // Always allow in local if debug mode is active
  if (isDebugPresent()) {
    return true
  }

  // Technical cookies are always considered accepted (generally do not require explicit consent)
  if (group === 'technical') {
    return true
  }

  // Check if OnetrustActiveGroups is available and is a string.
  // If it's not a string or is empty, assume no consent for non-technical cookies.
  if (typeof OnetrustActiveGroups !== 'string' || OnetrustActiveGroups.trim() === '') {
    if (isDebugConsolePresent()) {
      console.warn(
        'OnetrustActiveGroups not found or not a non-empty string. Assuming no consent for non-technical cookies.'
      )
    }
    return false
  }

  const categoryId = ONETRUST_CATEGORY_IDS[group]

  if (!categoryId) {
    if (isDebugConsolePresent()) {
      console.warn(`No OneTrust category ID mapped for group: ${group}`)
    }
    return false
  }

  // Convert the OnetrustActiveGroups string into an array to use .includes()
  const activeGroupsArray = OnetrustActiveGroups.split(',')

  // OnetrustActiveGroups contains the IDs of the categories that the user has consented to.
  return activeGroupsArray.includes(categoryId)
}

let blockedCookies = []

function manageBlockedCookie(cookie) {
  const index = blockedCookies.findIndex(c => c['name'] === cookie['name'])
  if (index === -1) {
    blockedCookies.push(cookie)
  } else {
    blockedCookies[index] = cookie // Update if already blocked
  }
  if (isDebugConsolePresent()) {
    console.log(`Blocked cookie: ${cookie['name']} (consent not given)`)
  }
}

function cookieIsAccepted(cookie) {
  const group = getGroupOfCookie(cookie['name'])

  // Always allow in local if debug mode is active
  if (isDebugPresent()) {
    return true
  }

  // Always allow deleting cookies. For adding, we check the group.
  // Deletion is indicated by expires being in the past or -1.
  const isDeletion = cookie['expires'].toString().includes('Jan 01 1970') || cookie['expires'].toString() === '-1'

  if (isDeletion) {
    return true // Always allow deletion
  }

  // For setting cookies, check if the group is accepted
  if (groupIsAccepted(group)) {
    return true
  }

  // If not accepted, it will be added to blockedCookies in setCookies
  return false
}

function manageConsentChanged(callAjaxUtag = true, callSetPartner = true) {
  // Try to send the cookies that were previously blocked but now have consent
  const cookiesPreviouslyBlocked = [...blockedCookies]

  // Filter out cookies that are still not accepted after the consent change
  const newlyAcceptedCookies = cookiesPreviouslyBlocked.filter(cookie => cookieIsAccepted(cookie))

  if (newlyAcceptedCookies.length > 0) {
    if (isDebugConsolePresent()) {
      console.log(`Attempting to set ${newlyAcceptedCookies.length} previously blocked cookies.`)
    }
    setCookies(newlyAcceptedCookies, () => {
      // Callback after setting cookies
      if (callAjaxUtag && typeof ajax_utag_callback !== 'undefined') {
        if (isDebugConsolePresent()) {
          console.log('Triggering ajax_utag_callback...')
        }
        ajax_utag_callback()
      }

      if (callSetPartner && typeof IB.partner !== 'undefined') {
        if (isDebugConsolePresent()) {
          console.log('Showing partner logo...')
        }
        IB.partner.showPartnerLogo()
      }
    })

    blockedCookies = cookiesPreviouslyBlocked.filter(cookie => !cookieIsAccepted(cookie))
  }
}

function getDomainForCookie() {
  return `.${document.domain.split('.').slice(-2).join('.')}`
}

/**
 * This function handles the logic for re-evaluating cookies based on OneTrust consent.
 * It will be called on initial load and whenever consent changes.
 */
let isFirstConsentUpdate = true
function handleOneTrustConsentUpdate() {
  if (isDebugConsolePresent()) {
    console.log('OneTrust consent updated. Re-evaluating cookies...')
  }

  let callAjaxUtag = true
  let callSetPartner = true
  const cookiesToDelete = []

  // In first update, set ot_consent_cookie
  if (isFirstConsentUpdate) {
    const areOneTrustCookiesPreviouslyAccepted = readCookie('onetrust_cookies_consent') === 'true'
    if (!areOneTrustCookiesPreviouslyAccepted) {
      setCookie('onetrust_cookies_consent', 'true')
    }
    isFirstConsentUpdate = false
  }

  // Check consent for Analytics cookies
  if (!groupIsAccepted('analytics')) {
    if (isDebugConsolePresent()) {
      console.log('Analytics cookies not consented. Preparing for deletion...')
    }
    ANALYTICS_COOKIES.forEach(s => {
      cookiesToDelete.push(s)
    })
    callAjaxUtag = false // If analytics is off, don't trigger utag data load
    sessionStorage.setItem('utag_user', '') // Clear utag_user if analytics is off
  }

  // Check consent for Personalization cookies
  if (!groupIsAccepted('personalization')) {
    if (isDebugConsolePresent()) {
      console.log('Personalization cookies not consented. Preparing for deletion...')
    }
    PERSONALIZATION_COOKIES.forEach(s => {
      cookiesToDelete.push(s)
    })
    callSetPartner = false // If personalization is off, hide partner logo
    if (typeof IB.partner !== 'undefined' && readCookie('cp_promotional') !== 'false') {
      IB.partner.hidePartnerLogo()
    }
  }

  // Delete cookies that are no longer consented
  if (cookiesToDelete.length > 0) {
    deleteCookies(cookiesToDelete, () => {
      manageConsentChanged(callAjaxUtag, callSetPartner)
    })
  } else {
    // If no cookies to delete, just manage consent changed (e.g., enable previously blocked cookies)
    manageConsentChanged(callAjaxUtag, callSetPartner)
  }
}

// --- OneTrust Integration Entry Point ---
// This function is the actual handler that will be executed when OptanonWrapper is called.
// It ensures that any existing OptanonWrapper logic is preserved and executed.
let hasExecutedOptanonLogic = false // Flag to ensure executeOptanonWrapperLogic runs only once

const executeOptanonWrapperLogic = function () {
  if (hasExecutedOptanonLogic) {
    return // Already executed, prevent re-execution from multiple triggers
  }
  hasExecutedOptanonLogic = true

  if (isDebugConsolePresent()) {
    console.log('OneTrust OptanonWrapper logic executed. Initializing cookie manager with OneTrust.')
  }
  // Initial check and management of cookies based on current consent
  handleOneTrustConsentUpdate()

  // Register a callback for when consent changes
  // OneTrust.OnConsentChanged is the correct event for consent changes.
  // This ensures our handler is added to the list of callbacks, not overwriting others.
  if (typeof OneTrust !== 'undefined' && typeof OneTrust.OnConsentChanged === 'function') {
    OneTrust.OnConsentChanged(handleOneTrustConsentUpdate)
  } else if (isDebugConsolePresent()) {
    console.warn('OneTrust.OnConsentChanged not found. Consent changes will not be automatically handled.')
  }
}

// --- OneTrust Integration Strategy ---
// This function attempts to integrate with OneTrust using its preferred OptanonWrapper mechanism.
// If that fails or OneTrust is slow to load, it falls back to a polling mechanism.
const initOneTrustIntegration = function () {
  let oneTrustReady = false // Flag to indicate if OneTrust is fully ready and our logic has run

  // Try to integrate via OptanonWrapper first (OneTrust's preferred method)
  // This covers cases where our script loads before or after OneTrust, and OneTrust uses OptanonWrapper.
  if (typeof window.OptanonWrapper === 'function') {
    // Scenario 1: OptanonWrapper is already a function (OneTrust script loaded and defined it).
    // We wrap it to execute both the original and our logic.
    if (isDebugConsolePresent()) {
      console.log('OneTrust OptanonWrapper is a function. Wrapping it.')
    }
    const originalOptanonWrapper = window.OptanonWrapper
    window.OptanonWrapper = function () {
      originalOptanonWrapper() // Execute original OneTrust logic
      executeOptanonWrapperLogic() // Execute our cookie manager logic
    }
    oneTrustReady = true // Assume it will be handled by the wrapper
  } else if (Array.isArray(window.OptanonWrapper)) {
    // Scenario 2: OptanonWrapper is an array (OneTrust script not yet loaded, but a queue exists).
    // We push our logic to the queue. OneTrust will process this array when it loads.
    if (isDebugConsolePresent()) {
      console.log('OneTrust OptanonWrapper is an array. Pushing logic to queue.')
    }
    window.OptanonWrapper.push(executeOptanonWrapperLogic)
    oneTrustReady = true // Assume it will be handled by the queue
  } else {
    // Scenario 3: OptanonWrapper doesn't exist yet.
    // We create it as an array and push our logic. OneTrust will later replace this array.
    if (isDebugConsolePresent()) {
      console.log('OneTrust OptanonWrapper not found. Creating array and pushing logic.')
    }
    window.OptanonWrapper = [executeOptanonWrapperLogic]
    oneTrustReady = true // Assume it will be handled by the newly created queue
  }

  // Fallback: If OneTrust wasn't ready via OptanonWrapper hook immediately,
  // or if the OptanonWrapper mechanism somehow fails to trigger our logic,
  // we start polling to ensure our logic eventually runs once OneTrust is truly available.
  // This is a safety net.
  if (!oneTrustReady || !hasExecutedOptanonLogic) {
    // Check if OptanonWrapper hook didn't directly trigger our logic
    if (isDebugConsolePresent()) {
      console.log('Starting polling for OneTrust readiness as a fallback.')
    }
    let pollAttempts = 0
    const maxPollAttempts = 20 // Max 20 attempts * 300ms = 6 seconds
    const pollInterval = 300 // Check every 300ms

    const oneTrustPollingInterval = setInterval(() => {
      if (hasExecutedOptanonLogic) {
        // Our logic has run, stop polling
        clearInterval(oneTrustPollingInterval)
        return
      }

      pollAttempts++
      // Check if OneTrust object and OnetrustActiveGroups are available
      if (typeof window.OneTrust !== 'undefined' && typeof window.OnetrustActiveGroups !== 'undefined') {
        clearInterval(oneTrustPollingInterval)
        executeOptanonWrapperLogic() // Execute our logic
      } else if (pollAttempts >= maxPollAttempts) {
        clearInterval(oneTrustPollingInterval)
      }
    }, pollInterval)
  }
}

;(function () {
  if (typeof IB === 'undefined') {
    window.IB = {}
  }

  IB.cookieManager = {
    blockedCookies,
    groupIsAccepted,
    cookieIsAccepted,
    manageConsentChanged,
    setCookies,
    deleteCookies,
    getDomainForCookie,
    isOneTrust: false,
    isGA: false,
  }
})()

const ibh_site = typeof ibh !== 'undefined' ? ibh.page.site : undefined
const isOneTrustEnabledInCurrentSite = !ONETRUST_DISABLED_SITES.includes(ibh_site)
const isCookiesPopup = document.documentElement.dataset.cookiesPopup === 'true'
const shouldEnableOneTrustForPopup = isCookiesPopup && isOneTrustEnabledInCurrentSite
if (isOneTrustEnabledInCurrentSite || shouldEnableOneTrustForPopup) {
  IB.cookieManager.isOneTrust = true
  if (isDebugConsolePresent()) {
    console.log('This site has OneTrust enabled')
  }
  // Execute the OneTrust integration logic immediately when this script loads.
  initOneTrustIntegration()
} else {
  IB.cookieManager.isGA = true
  import('./cookie_manager_ga')
  if (isDebugConsolePresent()) {
    console.log('This site has OneTrust disabled')
  }
}
if (isDebugConsolePresent()) {
  console.groupEnd()
}
